import { render, staticRenderFns } from "./CopyOrder.vue?vue&type=template&id=3acf5d02&scoped=true&"
import script from "./CopyOrder.vue?vue&type=script&lang=js&"
export * from "./CopyOrder.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=3acf5d02&lang=less&scoped=true&"
import style1 from "./CopyOrder.vue?vue&type=style&index=1&id=3acf5d02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acf5d02",
  null
  
)

export default component.exports